import { ReactNode, useEffect, useRef } from "react";
import { styled } from "@mui/material";

import { Footer } from "../../../footer/footer";
import Header from "../Header";
import { supportedLanguages } from "../../../../constants";
import { getCurrentUserData } from "../../../../redux/slices/current-user.slice";
import { changeLanguage } from "../../../../redux/slices/messages.slice";
import { setGlobalHeaderRef } from "../../../shared/refs";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { MessageLoader } from "../../../../router/blocks/route-components/message.loader";
import { MessageSections } from "../../../components/message/message";

type HomeLayoutProps = {
  children: ReactNode;
};

const StyledLayout = styled("div")`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
`;

const Content = styled("main")`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Layout = ({ children }: HomeLayoutProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const headerRef = useRef<HTMLDivElement>(null);

  const location = useLocation();
  const token = localStorage.getItem("access_token");
  const { language } = useParams();
  const { languageId } = useAppSelector((state) => state.messagesReducer);

  const paramsLanguageIndex = supportedLanguages.findIndex(
    (abbr) => abbr === language,
  );
  const paramsLanguageId =
    paramsLanguageIndex !== -1 ? paramsLanguageIndex + 1 : undefined;
  const path = location.pathname;

  useEffect(() => {
    setGlobalHeaderRef(headerRef);

    if (!paramsLanguageId) {
      dispatch(changeLanguage(1));
      navigate("/hy", { replace: true });
    } else if (paramsLanguageId !== languageId) {
      dispatch(changeLanguage(paramsLanguageId));
    }

    const modifiedPath = path.replace(
      `/${supportedLanguages[languageId]}/`,
      `/${language}/`,
    );

    if (modifiedPath !== path) {
      navigate(path + location.search + location.hash);
    } else {
      if (token) {
        dispatch(getCurrentUserData());
      }
    }
  }, [paramsLanguageId, token]);

  return (
    <MessageLoader
      key={MessageSections.MAIN + languageId}
      sectionName={MessageSections.MAIN}
    >
      <StyledLayout>
        <Header />
        <Content>{children}</Content>
        <div id="contact" style={{ width: '100%' }}>
          <Footer />
        </div>
      </StyledLayout>
    </MessageLoader>
  );
};

export default Layout;
